import EfModal from '@/components/UI/Modal';
import { getLang } from 'lowcomp/plugins/member/utils';
import { useRouter } from 'next/router';
import React from 'react';
import { TextLang } from '../../../TextLang';
import Coupon from '../../Coupon2';
import css from './index.module.scss';
interface NoteModalProps {
    disabledCoupon?: boolean;
    currNotes: any;
    setCurrNotes: (currNotes?: string[] | null) => void;
}

const NoteModal: React.FC<NoteModalProps> = ({ currNotes, disabledCoupon, setCurrNotes }) => {
    const router = useRouter();
    const { locale = 'us' } = router;
    const t = getLang(TextLang, locale);
    return (
        <EfModal
            className={css.efmodal}
            open={!!currNotes}
            visible={!!currNotes}
            zIndex={1200}
            onCancel={() => {
                setCurrNotes(null);
            }}
        >
            <div className="coupon-container">
                <Coupon
                    className="coupon-content"
                    coupon={currNotes}
                    disabled={disabledCoupon}
                    hideBtn
                    hideNote
                    hideCopyIcon
                    hideAmount={['THIRD_COUPONS', 'FREE_PRODUCTS'].includes(currNotes?.ruleType)}
                />
            </div>

            <div className="note-content">
                <h5 className="note-title">{t('rules')}</h5>
                <ul>
                    {currNotes?.noteList?.map((note: string, index: number) => (
                        <li key={index} className="note-item">
                            {note}
                        </li>
                    ))}
                </ul>
            </div>
        </EfModal>
    );
};

export default NoteModal;
